import angular from 'angular';

export const MeurhArquivosEmpresaRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider) {
		$stateProvider
			.state('meurh_arquivos_empresa', {
				url: '/arquivos',
				template: require('html-loader!./index/arquivos.empresa.index.html'),
				controller: 'MeurhArquivosEmpresaIndexController',
				controllerAs: 'mrh_rqvs_mprs_ndx_cntrllr',
        		reloadOnSearch: false,
			});
	}
];
